<template>
    <div class="ml-3">
        <a @click="onMenu">
            <div class="nav-dropdown" >
                <v-icon color="primary" class="nav-icon mr-2">mdi-clipboard-outline</v-icon>
                <v-badge :content="total" :color="totalColor" :tile="true">  </v-badge>
                <i class="nav-icon fas fa-caret-down" style="margin-left: 25px; font-size: 22px!important;"></i>
            </div>
        </a>
    </div>
</template>

<script>

import 'simplebar/dist/simplebar.min.css';

export default {
    name: "CIncClipboardMenu",

    props: {
        value: {
            required: true
        }
    },

    computed: {
        clipboardEntries () {
            return this.$store.getters.clipboard;
        },

        total() {
            const entries = this.clipboardEntries;
            if (!entries || entries.length === 0) {
                return "0";
            }

            return entries.length;
        },

        totalColor() {
            const entries = this.clipboardEntries;
            return entries && entries.length > 0 ? "red" : this.$vuetify.theme.themes.light.primary;
        },
    },

    created() {
    },

    methods: {
        onMenu () {
            this.$emit("input", true);
        }
    }
}

</script>

<style scoped>

</style>
